module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FueraServicio"
    }
  }, [_c('div', [_vm._v("Chilempleo::2020")]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/re.jpg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7877b970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FueraServicio.vue
// module id = 654
// module chunks = 1